module Meevo.Plugins.CallCenter {
  
    class MissedOpportunityModalController {
      
          private scope: any;
          private modal: angular.material.IDialogService;
          private message: string;
          private modalClass: string;
          private okButtonContentKey: string;
          private headerContentKey: string;

          protected missedOpportunities: any;
          protected guidDictionary: Map<Guid, string>;
  
          static $inject = ["$scope", "$mdDialog", "$translate"];
  
          constructor($scope: angular.IScope,
            $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            showEmpName: boolean) {
  
            let vm = this;
            vm.scope = $scope;
            vm.modal = $mdDialog;

            this.configureModal();  
          }
  
          public submitMissedOpportunity(): void {
            this.modal.hide(true);
          }

          private configureModal():void {
            this.modalClass = "modal-confirm";
            this.headerContentKey = "MESSAGE_MISSED_OPPORTUNITIES_ADDED";
            this.okButtonContentKey = this.$translate.instant("LABEL_OK");
            }

        cancel = () => {
            this.modal.cancel(false);
        }

    }
  
    angular.module("meevo.plugins.callCenter")
      .controller("meevo.plugins.callCenter.missedOpportunityModalController", MissedOpportunityModalController);
  }